module.exports = __webpack_public_path__ + "img/07_logo_2_compal_white.eb9a2da5.svg";